var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "ex-bg-pink",
        class: { "ex-bg-white": _vm.isShownLink == false }
      },
      [
        _c(
          "div",
          { staticClass: "tour-num pt-0 pl-0 pr-0" },
          [
            _c("tour-info", { attrs: { tourInfoProp: _vm.tourInfo } }),
            _vm._v(" "),
            _vm.errorMessage
              ? _c(
                  "div",
                  {
                    staticClass: "error-message",
                    staticStyle: { margin: "5px 25px" }
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("i", { staticClass: "icon-warning mr-2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "errror-txt" }, [
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.$t("error.title")))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.errorMessage))
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShownCash
              ? _c(
                  "div",
                  { staticClass: "block-cnt" },
                  [
                    _c("div", { staticClass: "heading-box" }, [
                      _vm._v(_vm._s(_vm.$t("cash.select_from_list")))
                    ]),
                    _vm._v(" "),
                    _vm.utils.isCooperator()
                      ? _c("InputT", {
                          staticStyle: { margin: "0 auto", width: "auto" },
                          model: {
                            value: _vm.selectedInputT,
                            callback: function($$v) {
                              _vm.selectedInputT = $$v
                            },
                            expression: "selectedInputT"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "scroll-list" },
                      [
                        _vm._l(_vm.ownListCash, function(element, index) {
                          return _c(
                            "div",
                            { key: "key" + index, staticClass: "table-detail" },
                            [
                              _vm.selectedInputT.id === 1 &&
                              _vm.utils.isCooperator()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "detail-block",
                                      class: {
                                        "ex-block-heading":
                                          _vm.activeCash === index
                                      },
                                      attrs: { name: "index" },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickCash(
                                            element.carrying_prepayment_item_id,
                                            index,
                                            element.name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(_vm._s(_vm.$t("cash.name")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(_vm._s(element.name))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(_vm._s(_vm.$t("cash.period")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.dateUtils.formatDateYYYYMMDD(
                                                  element.days_from
                                                )
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm.dateUtils.getDay(
                                                  element.days_from
                                                )
                                              ) +
                                              ")〜\n                                    "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.dateUtils.formatDateYYYYMMDD(
                                                  element.days_to
                                                )
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm.dateUtils.getDay(
                                                  element.days_to
                                                )
                                              ) +
                                              ")\n                                "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("cash.total_amount_sp")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.utils.formatPrice(
                                                element.total_deposit,
                                                _vm.currency_id
                                              )
                                            ) +
                                              _vm._s(
                                                _vm.getCurrencyName(
                                                  _vm.currency_id
                                                )
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("cash.notice_c"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(_vm._s(element.notice_c))
                                        ])
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.listCash, function(element, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "table-detail" },
                            [
                              _vm.selectedInputT.id === 2 ||
                              !_vm.utils.isCooperator()
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "detail-block",
                                      class: {
                                        "ex-block-heading":
                                          _vm.activeCash === index
                                      },
                                      attrs: { name: "index" },
                                      on: {
                                        click: function($event) {
                                          return _vm.clickCash(
                                            element.carrying_prepayment_item_id,
                                            index,
                                            element.name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(_vm._s(_vm.$t("cash.name")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(_vm._s(element.name))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(_vm._s(_vm.$t("cash.period")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.dateUtils.formatDateYYYYMMDD(
                                                  element.days_from
                                                )
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm.dateUtils.getDay(
                                                  element.days_from
                                                )
                                              ) +
                                              ")〜\n                                    "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.dateUtils.formatDateYYYYMMDD(
                                                  element.days_to
                                                )
                                              ) +
                                              "(" +
                                              _vm._s(
                                                _vm.dateUtils.getDay(
                                                  element.days_to
                                                )
                                              ) +
                                              ")\n                                "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("cash.total_amount_sp")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.utils.formatPrice(
                                                element.total_deposit,
                                                _vm.currency_id
                                              )
                                            ) +
                                              _vm._s(
                                                _vm.getCurrencyName(
                                                  _vm.currency_id
                                                )
                                              )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-row" }, [
                                        _c("label", { staticClass: "row-lb" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("cash.notice_c"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "row-cnt" }, [
                                          _vm._v(_vm._s(element.notice_c))
                                        ])
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isShownButton
              ? _c(
                  "div",
                  {
                    staticClass:
                      "mt-3 d-flex justify-content-center pl-25 pr-25"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row no-gutters w-100 justify-content-center"
                      },
                      [
                        _c("div", { staticClass: "col-6 pr-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-white-44 w-100 fs-18",
                              on: {
                                click: function($event) {
                                  _vm.isShownLink = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.after_certi")))]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.isShownCashButton
                          ? _c("div", { staticClass: "col-6 pl-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-pink-44 w-100 fs-18",
                                  on: { click: _vm.clickCashButton }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("voucher.general.create_detail")
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.isShownLink
          ? _c("div", { staticClass: "box-bottom-pink" }, [
              _c("div", { staticClass: "btns-box" }, [
                _c("ul", { staticClass: "lst-btns" }, [
                  !_vm.utils.isCooperator()
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-white-38 ex-has-icon",
                            on: {
                              click: function($event) {
                                return _vm.toVoucherByGroup(
                                  _vm.constants.GroupVoucherType.invoice_bill.id
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("voucher.group.invoice_bill")) +
                                "\n                            "
                            ),
                            _c("i", { staticClass: "icon-triangle-orange" })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-white-38 ex-has-icon",
                        on: {
                          click: function($event) {
                            return _vm.toVoucherByGroup(
                              _vm.constants.GroupVoucherType
                                .local_expense_voucher.id
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t("voucher.group.local_expense_voucher")
                            ) +
                            "\n                            "
                        ),
                        _c("i", { staticClass: "icon-triangle-orange" })
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f54c1cbc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54c1cbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Tour/AfterInput.vue
// module id = null
// module chunks = 